/*
Prakash 10/29/2022 2698811066 added styling classes for buttons.
Ashraf 12/13/2022 2698811066 renamed cancel button to reset
Raghu 12/13/2022 2698811066 Field Font-size fixes
 Lalitha 12/16/2022 2698811066  disable save button if account no null
  dilip 12/16/2022 2698811066  added document description
Asharf 12/28/2022 2698811066 conditional render of classes for widget fields
Asharf 12/29/2022 2698811066 reset form after submit
suresh peddavoora 02/28/2023 2698811066 New UI changes
suresh peddavoora 03/02/2023 2698811066 New Ui changes


*/

import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {FormControl, Grid, Button, TextField, FormHelperText} from '@material-ui/core';
import {useLocation} from 'react-router';
import PageLoader from '../../../components/PageLoader';
import DragAndDrop from './Drag&Drop';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  resetToast,
  scanDocumentManagement,
  docSubType,
  fetchDocumentManagement,
} from '../../../redux/reducers/DocumentManagement';
import {ThemeContext} from '../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const ScanForm = ({
  handleNext,
  handleBack,
  handleReset,
  activeStep,
  setActiveStep,
  steps,
  sideBarScan,
}) => {
  const location = useLocation();
  const accountNumber = location?.state?.accountNumber;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [warningOpen, setWarningOpen] = useState(false);
  const {subType, dropDownData, isLoading, errorMsg, successMsg} = useSelector(
    ({documentManagement}) => documentManagement,
  );
  const [valueCode, setValueCode] = useState({
    parentValueCode: '',
    childTypeCode: 'SUB_DOC_TYPE',
  });

  const dispatch = useDispatch();
  const initialValues = {
    type: '',
    subType: '',
    queryOn: 'none',
    documentDescription: '',
    endDate: null,
    startDate: null,
    uploadedFile: null,
  };

  useEffect(() => {
    dispatch(fetchDocumentManagement());
  }, [valueCode]);

  useEffect(() => {
    if (valueCode) {
      dispatch(docSubType(valueCode));
    }
  }, [valueCode]);
  const schema = Yup.object().shape({
    type: Yup.mixed().test('type', 'Document type is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),

    subType: Yup.mixed().test('subType', 'Document Subtype is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
    uploadedFile: Yup.mixed()
      .test('uploadedFile', 'Please upload the file', function(value, context) {
        const {from} = context;
        const uploadedFile = from[0]?.value?.uploadedFile;
        if (uploadedFile === null) {
          return false;
        } else {
          return true;
        }
      })
      .nullable(),
    documentDescription: Yup.string()
      .max(40, 'Document Description cannot exceed 40 characters')
      .required('Document Description is required'),
  });
  const [fileSizeError, setFileSizeError] = useState(false);

  return (
    <>
      <Formik
        onSubmit={(values, {resetForm}) => {
          const {type, subType, documentDescription} = values;

          /* const formData = new FormData();
          formData.append('multipartFile', values.uploadedFile[0]);
          formData.append(
            'scanRequest',
            new Blob(
              [
                JSON.stringify({
                  accountNumber: accountNumber,
                  documentSubtype: subType.valueCode,
                  documentType: type.valueCode,
                  documentDescription: documentDescription,
                }),
              ],
              {type: 'application/json'},
            ),
          ); */
          if (values && values.uploadedFile && accountNumber) {
            const file = values.uploadedFile[0];
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              dispatch(scanDocumentManagement({
                file: reader.result.split(',')[1],
                fileName: file.name,
                accountNumber: accountNumber,
                documentDescription: documentDescription,
                documentType: type.valueCode,
                documentSubtype: subType.valueCode
              }, accountNumber));
              resetForm();
              setTimeout(() => {
                dispatch(resetToast());
              }, 5000);
            }
            // dispatch(scanDocumentManagement(formData, accountNumber));
          }
          setTimeout(() => {
            dispatch(resetToast());
            resetForm(initialValues);
          }, 5000);
        }}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleSubmit,
            handleReset,
            setFieldValue,
            handleChange,
            handleBlur,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
              <div className={`${sideBarScan ? '' : 'col'}`}>
                <Grid
                  container
                  className="global-field-textfields new-standard-textfields"
                  spacing={2}
                >
                  <Grid item sm={sideBarScan ? 12 : 6} className="form-group">
                    <div className="common-input-field ">
                      <FormControl className="w-100" margin="dense" variant="outlined" fullWidth>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="type"
                          name="type"
                          size="small"
                          value={values.type}
                          options={
                            dropDownData && dropDownData.DOC_TYPE ? dropDownData.DOC_TYPE : []
                          }
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                '';
                          }}
                          onBlur={handleBlur}
                          onChange={(e, value) => {
                            setFieldValue('type', value ? value : '').then(() => {
                              setFieldValue('subType', '');
                            });
                            setValueCode(
                              value && value.valueCode ?
                                {...valueCode, parentValueCode: value.valueCode} :
                                valueCode,
                            );
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              {...params}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              className={` ${classes.labelName}`}
                              required
                              name="type"
                              variant="outlined"
                              label="Document Type"
                              placeholder="Select Document Type"
                              error={!values?.type && errors.type && touched.type}
                            />
                          )}
                        />
                      </FormControl>
                      {!values?.type && (
                        <FormHelperText margin="dense" variant="outlined">
                          {touched.type && errors.type ? errors.type : null}
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>
                  <Grid item sm={sideBarScan ? 12 : 6} className="form-group">
                    <div className="common-input-field ">
                      <FormControl className="w-100" margin="dense" variant="outlined" fullWidth>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="subType"
                          name="subType"
                          size="small"
                          value={values.subType}
                          options={values?.type?.typeCode && subType ? subType : []}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                '';
                          }}
                          onBlur={handleBlur}
                          onChange={(e, value) => {
                            setFieldValue('subType', value ? value : '');
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          renderInput={(params) => (
                            <GuiTextField
                              {...params}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              className={` ${classes.labelName}`}
                              required
                              name="subType"
                              variant="outlined"
                              label="Document Subtype"
                              placeholder="Select Document Subtype"
                              error={errors.subType && touched.subType}
                            />
                          )}
                        />
                      </FormControl>
                      <FormHelperText margin="dense" variant="outlined">
                        {touched.subType && errors.subType && errors.subType}
                      </FormHelperText>
                    </div>
                  </Grid>
                  <Grid item sm={12} md={12} className="form-group">
                    <div className="common-input-field ">
                      <FormControl className="w-100" margin="dense" variant="outlined" fullWidth>
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          name="documentDescription"
                          variant="outlined"
                          type="text"
                          placeholder="Enter Document Description"
                          label="Document Description"
                          value={values.documentDescription}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          fullWidth
                          error={errors.documentDescription && touched.documentDescription}
                        />
                      </FormControl>
                      <FormHelperText margin="dense" variant="outlined">
                        {touched.documentDescription &&
                          errors.documentDescription &&
                          errors.documentDescription}
                      </FormHelperText>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <DragAndDrop
                      setFieldValue={setFieldValue}
                      uploadedFile={values.uploadedFile}
                      fileSizeError={fileSizeError}
                      error={errors.uploadedFile}
                      helperText={errors && errors.uploadedFile}
                      setFileSizeError={setFileSizeError}
                      setWarningOpen={setWarningOpen}
                      warningOpen={warningOpen}
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={4} md={4} lg={12}>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        marginLeft: "5px",
                      }}
                    ></div>
                  </Grid> */}
                </Grid>

                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="reset"
                    onClick={() => setFileSizeError(false)}
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  >
                    Reset
                  </Button>
                  <Button
                    type={!fileSizeError ? 'submit' : 'button'}
                    variant="outlined"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={isLoading || !accountNumber}
                  >
                    Save
                  </Button>
                </div>
              </div>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default ScanForm;
